/* @ngInject */
export default function ($sce) {
	return (msg, isXHTML) => {
		isXHTML = isXHTML || true;

		let breakTag = (isXHTML) ? '<br />' : '<br>';

		msg = (msg + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');

		return $sce.trustAsHtml(msg);
	};
};


// WEBPACK FOOTER //
// ./src/js/filters/nl2br.js